import styled from 'styled-components';
import { media } from 'theme';

export const SearchOptionItem = styled.li`
  font-size: 14px;
  cursor: pointer;
  color: ${props =>
    props.isSelected
      ? props.theme.colors.seedlyBlue
      : props.theme.colors.neutral5};
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: ${props =>
    props.isSelected ? `2px solid ${props.theme.colors.seedlyBlue}` : 'none'};
  white-space: nowrap;
`;

export const SearchOptionList = styled.ul`
  margin-left: 10px;

  > * {
    display: inline-block;
    margin-right: 40px;
  }

  ${media.largeAndDown`
    display: flex;
    overflow-x: scroll;
    margin-left: 20px;
    margin-right: 10px;

     > * {
      display: inline-block;
      margin-right: 28px;
    }
  `}
`;
